import * as sales from './list'

import { Sale } from 'app/types/transactions/sale'

export const allSales: Sale[] = Object.values(sales).sort((previous, current) =>
    current.date_time.localeCompare(previous.date_time),
)
